export default function renderIcon({ color = '#575d96', width = '31.805', height = '27.83' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 31.805 27.83">
      <path id="Icon_open-account-login" data-name="Icon open-account-login" d="M11.927,0V3.976h15.9V23.854h-15.9V27.83H31.805V0ZM15.9,7.951v3.976H0V15.9H15.9v3.976l7.951-5.963Z" fill={color} />
    </svg>
  )
}
